import { FileViewer, type FileSource } from '@powerportalspro/react-fluent';

const jsonText = `{
  "name": "ImageViewer",
  "features": ["rotate", "zoom", "flip", "crop"],
  "version": "1.0"
}`;

const source: FileSource = {
  kind: 'bytes',
  value: new TextEncoder().encode(jsonText),
  fileName: 'manifest.json',
};

export function FileViewerTextSample() {
  return <FileViewer source={source} fileName="manifest.json" maxHeight="220px" />;
}
